import { createWorkerAction } from '../../lib';
export var logout = createWorkerAction('LOGOUT');
